lazyframe('.lazyframe');

function getObjectWidth(obj) {
    if (obj.offsetWidth) return obj.offsetWidth;
    if (obj.clip) return obj.clip.width;
    return 0;
}

class Marquee{
    constructor(id){
        this.containers = [];
        this.createContainer(id);
        this.rotateContainer(this.containers);
    }

    createContainer(id)
    {
        const element = 'span';
        const container = document.getElementById(id);
        const itemWidth = getObjectWidth(container.getElementsByTagName(element)[0]) + 5;
        const fullWidth = getObjectWidth(container);
        const textContent = container.getElementsByTagName(element)[0].innerHTML;
        container.innerHTML = '';
        const height = container.style.height;

        container.items = [];
        const maxItems = Math.ceil(fullWidth / itemWidth) + 1;

        for (let i = 0; i < maxItems; i++) {
            container.items[i] = document.createElement('div');
            container.items[i].className = 'marquee-container';
            container.items[i].innerHTML = textContent;
            container.items[i].style.position = 'absolute';
            container.items[i].style.left = itemWidth * i + 'px';
            container.items[i].style.width = itemWidth + 'px';
            container.items[i].style.height = height;
            container.appendChild(container.items[i]);
        }

        this.containers.push(container);
    }

    rotateContainer(containers)
    {
        if (!containers) return;

        for (let j = containers.length - 1; j > -1; j--) 
        {
            const maxItems = containers[j].items.length;
    
            for (let i = 0; i < maxItems; i++) {
                const itemStyle = containers[j].items[i].style;
                itemStyle.left = parseInt(itemStyle.left, 10) - 1 + "px";
            }
    
            const firstItemStyle = containers[j].items[0].style;
    
            if (parseInt(firstItemStyle.left, 10) + parseInt(firstItemStyle.width, 10) < 0) 
            {
                const shiftedItem = containers[j].items.shift();
                shiftedItem.style.left = parseInt(shiftedItem.style.left) + parseInt(shiftedItem.style.width) * maxItems + 'px';
                containers[j].items.push(shiftedItem);
            }
        }

        containers[0].animationID = window.requestAnimationFrame(() => this.rotateContainer(containers));
    }
}

function createMarquee(id){
    return new Marquee(id);
}

document.querySelectorAll('[data-slider]')?.forEach(el => {
    new Swiper(el.querySelector('.swiper'), {
        slidesPerView: 1,
        spaceBetween: 20,
        pagination: {
            el: el.querySelector('[data-slider-pagination]'),
            clickable: true
        }
    });
});

document.querySelectorAll('.product-tabs .product-tabs-nav li')?.forEach(el => {
    el.addEventListener('click', e => {
        e.preventDefault();
        document.querySelectorAll('.product-tabs .product-tabs-nav li')?.forEach(el => el.classList.remove('active'));
        document.querySelectorAll('.product-tabs-content')?.forEach(el => el.classList.remove('active'));
        e.target.classList.add('active');
        const tabContent = e.target.dataset.tabContent;
        document.querySelector(`.product-tabs-content[data-tab-content="${tabContent}"]`)?.classList.add('active');
    });
});

document.querySelectorAll('[data-product-disclosure-btn]')?.forEach(el => {
    el.addEventListener('click', e => {
        e.preventDefault();
        const action = e.currentTarget.dataset.productDisclosureBtn;
        const frontContent = document.querySelector('.product-disclosure-front-content');
        const backContent = document.querySelector('.product-disclosure-back-content');
        if(action == 'open' && frontContent && backContent){
            frontContent.style.display = 'none';
            backContent.style.display = 'block';
        }
        if(action == 'close' && frontContent && backContent){
            frontContent.style.display = 'block';
            backContent.style.display = 'none';
        }
    })
});

document.getElementById('show_passord_recovery')?.addEventListener('click', (e) => {
    e.preventDefault();
    document.getElementById('customer_login').style.display = 'none';
    document.getElementById('customer_password_recovery').style.display = 'block';
});

document.getElementById('show_login')?.addEventListener('click', (e) => {
    e.preventDefault();
    document.getElementById('customer_login').style.display = 'block';
    document.getElementById('customer_password_recovery').style.display = 'none';
});

if(window.location.href.match(/[#]recover/i) && window.location.pathname == '/account/login')
{
    document.getElementById('customer_login').style.display = 'none';
    document.getElementById('customer_password_recovery').style.display = 'block';
}

document.querySelectorAll('.video-preview')?.forEach(el => {
    el.addEventListener('click', e => {
        e.preventDefault();
        let videoWrapper = e.target.closest('.video-wrapper');
        if(videoWrapper){
            e.currentTarget.classList.add('hidden');
            videoWrapper.querySelector('video')?.play();
        }
    });
});

document.querySelectorAll('.disclosure-content-item-head')?.forEach(el => {
    el.addEventListener('click', e => {
        e.preventDefault();
        e.target.closest('.disclosure-content-item')?.classList.toggle('open');
    });
});

document.querySelectorAll('.product-tabs .product-tabs-nav li')?.forEach(el => {
    el.addEventListener('click', e => {
        e.preventDefault();
        document.querySelectorAll('.product-tabs .product-tabs-nav li')?.forEach(el => el.classList.remove('active'));
        document.querySelectorAll('.product-tabs-content')?.forEach(el => el.classList.remove('active'));
        e.target.classList.add('active');
        const tabContent = e.target.dataset.tabContent;
        document.querySelector(`.product-tabs-content[data-tab-content="${tabContent}"]`)?.classList.add('active');
    });
});

document.querySelectorAll('[data-product-disclosure-btn]')?.forEach(el => {
    el.addEventListener('click', e => {
        e.preventDefault();
        const action = e.currentTarget.dataset.productDisclosureBtn;
        const frontContent = document.querySelector('.product-disclosure-front-content');
        const backContent = document.querySelector('.product-disclosure-back-content');
        const imageColumn = document.querySelector('.product-content-image-disclosure .image-column');
        if(action == 'open' && frontContent && backContent){
            frontContent.style.display = 'none';
            backContent.style.display = 'block';
            imageColumn.classList.add('minify');
        }
        if(action == 'close' && frontContent && backContent){
            frontContent.style.display = 'block';
            backContent.style.display = 'none';
            imageColumn.classList.remove('minify');
        }
    });
});

document.getElementById('mobile_menu_open_btn')?.addEventListener('click', e => {
    e.preventDefault();
    document.body.classList.add('ovh');
    document.querySelector('.mobile-menu').classList.add('open');
});

document.getElementById('mobile_menu_close_btn')?.addEventListener('click', e => {
    e.preventDefault();
    document.querySelector('.mobile-menu').classList.remove('open');
    document.body.classList.remove('ovh');
});

document.querySelectorAll('.mobile-menu-navigation .has-child > [data-toggle]')?.forEach(el => {
    el.addEventListener('click', e => {
        e.preventDefault();
        e.currentTarget.closest('li').classList.toggle('open');
    });
});

document.querySelectorAll('.mobile-menu-navigation a[href="#"]')?.forEach(el => {
    el.addEventListener('click', e => {
        e.preventDefault();
    });
});

const mainHeader =  document.querySelector('.main-header');

document.addEventListener('scroll', () => {
    if(window.scrollY > 50){
        mainHeader.classList.add('sticky');
    }else{
        mainHeader.classList.remove('sticky');
    }
});

if(location.hash) {
    window.scrollTo(0, 0);
}

const scrollToElement = (element) => {
    const elementRect = element.getBoundingClientRect();
    let elementTop = elementRect.top + window.scrollY;

    if(window.innerWidth < 1100){
        elementTop -= 120;
    }

    window.scroll({
        behavior: 'smooth',
        top: elementTop
    });
}

function openKlaviyoForm(id)
{
    if(!id){
        return;
    }

    const xkf = sessionStorage.getItem('xkf');
    let data = xkf ? JSON.parse(xkf) : [];

    if(!data.includes(id)){
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', id]);
    }
}

document.addEventListener('DOMContentLoaded', () => {
    if(location.hash)
    {
        let findElementByHash = document.getElementById(location.hash.replace('#', ''));
        if(findElementByHash){
            scrollToElement(findElementByHash);
        }
    }

    document.querySelectorAll('a')?.forEach(item => {
        let href = item.getAttribute('href');
        if(href && href.match(/^#.+/))
        {
            item.addEventListener('click', e => {
                e.preventDefault();
                const target = e.currentTarget || e.target;
                const href = target.getAttribute('href');
                let findElementByHash = document.getElementById(href.replace('#', ''));
                if(findElementByHash){
                    scrollToElement(findElementByHash);
                } 
            });
        }
    });

    document.addEventListener('click', e => {
        const klaviyoFromCloseBtn = e.srcElement.matches('.klaviyo-close-form') || e.srcElement.closest('.klaviyo-close-form') || null;

        if(klaviyoFromCloseBtn?.nextElementSibling)
        {
            const klaviyoFrom = klaviyoFromCloseBtn.nextElementSibling;
            const idAttr = klaviyoFrom.getAttribute('data-testid');

            if(idAttr)
            {
                const id = idAttr.replace('klaviyo-form-', '');
                const xkf = sessionStorage.getItem('xkf');
                let data = xkf ? JSON.parse(xkf) : [];

                if(!data.includes(id)){
                    data.push(id);
                }

                sessionStorage.setItem('xkf', JSON.stringify(data));
            }
        }
    });
    
    const showHidePassBtn = document.getElementById('show_hide_pass');
    showHidePassBtn?.addEventListener('click', e => {
        e.preventDefault();

        let showPass = false;

        document.querySelectorAll('input[name="customer[password]"], input[name="customer[password_confirmation]"]')?.forEach(item => {
            if(item.type == 'password'){
                item.setAttribute('type', 'text');
                showPass = true;
            }else{
                item.setAttribute('type', 'password');
            }
        });

        if(showPass){
            showHidePassBtn.innerHTML = 'Hide password';
        }else{
            showHidePassBtn.innerHTML = 'Show password';
        }
    });
});

document.querySelectorAll('.cart-item-cell input')?.forEach(item => {
    item.addEventListener('change', e => {
        let value = parseInt(e.target.value);
        const id = e.target.dataset.id || null;
    
        if(!isNaN(value))
        {
            value = value < 0 ? 0 : value;
            window.location.href = `/cart/change?quantity=${value}&id=${id}`;
        }
    });
});

document.querySelectorAll('.footer-navigation-title')?.forEach(item => {
    item.addEventListener('click', e => {
        e.preventDefault();
        const parent = e.currentTarget.closest('.footer-navigation');
        if(parent && window.innerWidth < 1100){
            parent.classList.toggle('expanded');
        }
    });
});